import axios from "axios";
import {fetchAuthSession} from "aws-amplify/auth";

const instance = axios.create({
  //timeout: 10000,
});

export default instance;

// Add a response interceptor
instance.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    response.status = {
      loading: false,
      error: false,
    };
    return response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    return Promise.reject(error);
  }
);

instance.interceptors.request.use(async (config) => {
  let session;
  try {
    session = await fetchAuthSession();
  } catch {
    console.log("error fetching auth session");
    return config;
  }

  if (session?.tokens?.idToken) {
    config.headers["Authorization"] = `Bearer ${session.tokens.idToken}`;
  }

  if (config.requiresIdentityId) {
    config.headers["x-identityId"] = session.identityId;
  }

  return config;
});
